import React from 'react';
import { useSelector } from 'react-redux';
import Global from '../../../store/global-selectors';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { messages } from '../../../fulfillment-planner/labeled-row/messages';

import { LabeledRow } from '../../../fulfillment-planner/labeled-row';
import { ACCESS_LEVELS, useRequiresRateShopperAccessLevel } from '../../../hooks/use-has-rate-shopper-access-level';
import style from './style.module.css';

const RateShopper = ({ serviceCollectionGuid }) => {
  const showRateShopper = useRequiresRateShopperAccessLevel(ACCESS_LEVELS.FREEMIUM);
  const serviceCollection = useSelector((state) =>
    Global.selectSellerServiceCollectionByGuid(state, {
      serviceCollectionGuid,
    }),
  );

  if (!showRateShopper || !serviceCollectionGuid || !serviceCollection.name) {
    return null;
  }

  return (
    <LabeledRow className={style.row} label={<FormattedMessage {...messages.serviceCollection} />} labelClassName={style.label}>
      <span className={style.info}>{serviceCollection.name}</span>
    </LabeledRow>
  );
};

RateShopper.propTypes = {
  serviceCollectionGuid: PropTypes.string,
};

export default RateShopper;
